// extracted by mini-css-extract-plugin
module.exports =  {"alert":"PKctcKSZNdvVS3nEoqwU"};